/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Filters_AriaInputs */

const en_directory_home_board_filters_aria = /** @type {(inputs: Directory_Home_Board_Filters_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open filters to narrow the board`)
};

const zh_directory_home_board_filters_aria = /** @type {(inputs: Directory_Home_Board_Filters_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开筛选条件，缩小榜单范围`)
};

/**
* | output |
* | --- |
* | "Open filters to narrow the board" |
*
* @param {Directory_Home_Board_Filters_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_filters_aria = /** @type {((inputs?: Directory_Home_Board_Filters_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Filters_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_filters_aria(inputs)
	return zh_directory_home_board_filters_aria(inputs)
});
export { directory_home_board_filters_aria as "directory.home.board.filters_aria" }